// Imports
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Splash_splash__Whzwb {\n\tpadding: .5rem;\n\tmargin: 0 auto;\n\tmax-width: 800px;\n}\n.Splash_splash__Whzwb button {\n\tpadding: 0;\n\tmargin: 0;\n\tbackground: none;\n\tborder: 0;\n}", "",{"version":3,"sources":["webpack://src/Splash.module.css"],"names":[],"mappings":"AAAA;CACC,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;AACA;CACC,UAAU;CACV,SAAS;CACT,gBAAgB;CAChB,SAAS;AACV","sourcesContent":[".splash {\n\tpadding: .5rem;\n\tmargin: 0 auto;\n\tmax-width: 800px;\n}\n.splash button {\n\tpadding: 0;\n\tmargin: 0;\n\tbackground: none;\n\tborder: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"splash": "Splash_splash__Whzwb"
};
export default ___CSS_LOADER_EXPORT___;
